/**
 * Format price with 2 decimals and comma as decimal separator
 * @param {number|string} value - The price value
 * @returns {string} Formatted price string (e.g., "1000,50")
 */
export const formatPrice = (value) => {
  if (value === null || value === undefined || value === "") {
    return "0,00";
  }
  
  const numValue = typeof value === "string" ? parseFloat(value.replace(",", ".")) : value;
  
  if (isNaN(numValue)) {
    return "0,00";
  }
  
  return numValue.toFixed(2).replace(".", ",");
};

/**
 * Parse price string (with comma as decimal separator) to number
 * @param {string} value - The price string (e.g., "1000,50")
 * @returns {number} Parsed number
 */
export const parsePrice = (value) => {
  if (!value || value === "") {
    return 0;
  }
  
  // Replace comma with dot for parsing
  const normalized = value.toString().replace(",", ".");
  const parsed = parseFloat(normalized);
  
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Calculate price excluding VAT from price including VAT
 * @param {number} inclVat - Price including VAT
 * @param {number} vatPercentage - VAT percentage (e.g., 25 for 25%)
 * @returns {number} Price excluding VAT
 */
export const calculateExclVat = (inclVat, vatPercentage) => {
  if (!inclVat || inclVat === 0) return 0;
  if (!vatPercentage || vatPercentage === 0) return inclVat;
  
  return inclVat / (1 + vatPercentage / 100);
};

/**
 * Calculate price including VAT from price excluding VAT
 * @param {number} exclVat - Price excluding VAT
 * @param {number} vatPercentage - VAT percentage (e.g., 25 for 25%)
 * @returns {number} Price including VAT
 */
export const calculateInclVat = (exclVat, vatPercentage) => {
  if (!exclVat || exclVat === 0) return 0;
  if (!vatPercentage || vatPercentage === 0) return exclVat;
  
  return exclVat * (1 + vatPercentage / 100);
};

